import { LoadingButton } from '@mui/lab';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  StyledContainerItems,
  StyledTitleSideBar,
  StyledContainerFooterSideBar
} from '../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import Strings from '../../../i18n';
import {
  useGetFirmwareVersionsMutation,
  useScheduleFirmwareUpdateMutation
} from '../../../services/device/deviceService';
import { SelectItemMethod } from '../../../components/commons/SideBarComponents/SelectItemMethod/selectItemMethod';
import { useGetUpgradeTypesMutation } from '../../../services/firmwareVersions/firmwareVersionsService';

interface SendDirectFOTAProps {
  reloadTable: () => {};
  deviceIds: { deviceId: string; productTypeId: number }[];
  setOpenRightSideBar: (value: boolean) => void;
  clearSelectedDevices: () => void;
}
export const SendDirectFOTA = ({
  deviceIds,
  setOpenRightSideBar,
  clearSelectedDevices,
  reloadTable
}: SendDirectFOTAProps) => {
  const [
    sendDirectFOTA,
    { isSuccess: isSuccessSendDirectFOTA, isLoading: isLoadingSendDirectFOTA }
  ] = useScheduleFirmwareUpdateMutation();
  const [getUpgradeTypes, { data: dataUpgrade }] = useGetUpgradeTypesMutation();

  const [getVersions, { data: dataVersions }] =
    useGetFirmwareVersionsMutation();
  const [payloadFOTA, setPayloadFOTA] = useState({
    versionId: 0,
    deviceIds,
    upgradeTypeId: 0
  });

  const handleSubmit = () => {
    const formattedPayload = {
      ...payloadFOTA,
      deviceIds: payloadFOTA.deviceIds.map((device) => device.deviceId)
    };
    sendDirectFOTA(formattedPayload);
  };

  useEffect(() => {
    const uniqueProductTypeIds = [
      ...new Set(deviceIds.map((item) => item.productTypeId))
    ];
    getVersions(uniqueProductTypeIds);
  }, []);

  useEffect(() => {
    if (isSuccessSendDirectFOTA) {
      toast.success(Strings.serverAccess.devices.successSendDirectFOTA);
      reloadTable();
      setOpenRightSideBar(false);
    }
  }, [isSuccessSendDirectFOTA]);

  useEffect(() => {
    const noVersionSelected = 0;
    if (payloadFOTA.versionId !== noVersionSelected) {
      const firmwareVersion = dataVersions?.data.find(
        (item) => item.id === payloadFOTA.versionId
      );

      if (firmwareVersion) {
        getUpgradeTypes({ firmwareVersion: firmwareVersion.name });
      }
    }
  }, [payloadFOTA]);
  return (
    <>
      <StyledContainerItems>
        <StyledTitleSideBar>
          {Strings.serverAccess.devices.directFOTA}
        </StyledTitleSideBar>
        <SelectItemMethod
          item={{
            label: Strings.serverAccess.devices.compatibleVersions,
            options:
              dataVersions?.data
                ?.filter((item) => item.active)
                .slice()
                .sort((a, b) => {
                  const [majorA, minorA] = a.name.split('.').map(Number);
                  const [majorB, minorB] = b.name.split('.').map(Number);
                  return majorB - majorA || minorB - minorA;
                })
                .map((item) => ({
                  id: item.id,
                  name: item.minWifiModuleVersionName
                    ? `${item.name} (${item.minWifiModuleVersionName})`
                    : item.name
                })) || [],
            currentValue: payloadFOTA.versionId,
            onChange: (e) =>
              setPayloadFOTA({
                ...payloadFOTA,
                versionId: +e.target.value,
                upgradeTypeId: 1
              })
          }}
        />
        <SelectItemMethod
          item={{
            label: Strings.serverAccess.devices.upgradeBehavior,
            options: dataUpgrade || [],
            currentValue: payloadFOTA.upgradeTypeId,
            onChange: (e) =>
              setPayloadFOTA({ ...payloadFOTA, upgradeTypeId: +e.target.value })
          }}
        />
        <div className="alert alert-warning" role="alert">
          <h5>{Strings.serverAccess.devices.affectedControllers}</h5>
          <ul>
            {deviceIds.map((item) => (
              <li key={item.deviceId}>{item.deviceId}</li>
            ))}
          </ul>
        </div>
      </StyledContainerItems>

      <StyledContainerFooterSideBar>
        <button
          type="button"
          className="btn-cancel"
          onClick={() => {
            setOpenRightSideBar(false);
            clearSelectedDevices();
          }}
        >
          {Strings.common.cancel}
        </button>
        <button
          type="button"
          className="btn-save"
          disabled={payloadFOTA.versionId === 0 || isLoadingSendDirectFOTA}
          onClick={() => handleSubmit()}
        >
          {Strings.common.send}
        </button>
      </StyledContainerFooterSideBar>
    </>
  );
};
